export default {
  computed: {
    canRequestDraftContract() {
      return (
        this.insuranceCompany?.minuta &&
        this.insuranceCompany?.status?.id != "simulada"
      );
    },
    canRefuseDraftContractSelectedCost() {
      return false;
      // Desativado no momento, até que seja
      // definido melhor a regra para a recusa de minuta
      // return (
      //   this.insuranceCompany?.acoes?.minuta?.pode_recusar &&
      //   this.canRequestDraftContract
      // );
    },
    canRequestDraftContractSelectedCost() {
      return this.insuranceCompany?.acoes?.pode_formalizar;
    },
    canApproveDraftContractSelectedCost() {
      return (
        this.insuranceCompany?.acoes?.minuta?.pode_aprovar &&
        this.canRequestDraftContract
      );
    },
    canRequestApprovalDraftContractSelectedCost() {
      return (
        this.insuranceCompany?.acoes?.minuta?.pode_solicitar_aprovacao &&
        this.canRequestDraftContract
      );
    }
  }
};
